module.exports = __webpack_public_path__ + "static/media/Background.672fd06d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Background.jpg
// module id = 103
// module chunks = 0